// extracted by mini-css-extract-plugin
export var chevronIcon = "_67-2";
export var teamName = "_67-1";
export var teamSwitcherButton = "_67-0";